// get product data
const product = JSON.parse(document.querySelector(".productV2JSON").textContent);
let activeVariant = JSON.parse(document.querySelector(".variantV2JSON").textContent);

/**************
 Product Swiper
 **************/
    // setup product swiper
let productSwiper = null;

function initSwiper() {
    // re-init will replace the productSwiper
    productSwiper = new Swiper(document.querySelector(".productV2VisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        zoom: {
            maxRatio: 3,
            minRation: 1
        },
        breakpoints: {
            801: {
                zoom: {
                    maxRatio: 1
                },
            }
        },
        navigation: {
            nextEl: '.productV2VisualSwiper .swiper-button-next',
            prevEl: '.productV2VisualSwiper .swiper-button-prev',
        },
    });

    // slide change
    productSwiper.on('slideChange', function () {
        // update the thumbnail active class
        document.querySelectorAll(".productV2VisualThumbsSlide.active").forEach(el => el.classList.remove("active"));
        document.querySelectorAll(`.productV2VisualThumbsSlide[data-index="${productSwiper + 1}"]`).forEach(el => el.classList.add("active"));

        // pause all videos
        document.querySelectorAll(".productV2VisualSwiperSlide video").forEach(element => {
            element.pause();
        });
    });

    // play video on slide play click
    document.querySelectorAll(".productV2VisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productV2VisualSwiperSlide").querySelector("video");

            // remove play button if it hasn't already been removed
            this.querySelector(".productV2VisualSwiperSlidePlay")?.remove();

            if (video) {
                // show controls
                video.controls = true;

                // play video
                video.play();
            }
        });
    });

    // change slide on thumbnail click
    document.querySelectorAll(".productV2VisualThumbsSlide").forEach(element => {
        element.addEventListener("click", function () {
            // change slide
            productSwiper.slideTo(this.dataset.index - 1);
        });
    });

    // mobile thumbnail swiper
    const thumbnailSwiper = new Swiper(document.querySelector(".productV2VisualThumbs .swiper"), {
        slidesPerView: 'auto',
        // loop: true,
        navigation: {
            nextEl: '.productV2VisualThumbs .swiper-button-next',
            prevEl: '.productV2VisualThumbs .swiper-button-prev',
        },
    });

    // mobile active add
    document.querySelectorAll(".productV2VisualThumbsSlide.swiper-slide").forEach(element => {
        element.addEventListener("click", function () {
            document.querySelector('.productV2VisualThumbsSlide.swiper-slide.active')?.classList.remove('active');
            this.classList.add('active');
        });
    });
}

// initialize the swiper
initSwiper();

// main product swiper
const mainSwiper = new Swiper(document.querySelector(".productV2VisualMainSwiper"), {
    slidesPerView: 1,
    spaceBetween: 20,
    zoom: {
        maxRatio: 3,
        minRation: 1
    },
    breakpoints: {
        801: {
            zoom: {
                maxRatio: 1
            },
        }
    },
    navigation: {
        nextEl: '.productV2VisualMainSwiper .swiper-button-next',
        prevEl: '.productV2VisualMainSwiper .swiper-button-prev',
    },
});

// slide change
mainSwiper.on('slideChange', function () {
    // update the thumbnail active class
    document.querySelectorAll(".productV2VisualMain .productV2VisualThumbsSlide.active").forEach(el => el.classList.remove("active"));
    document.querySelectorAll(`.productV2VisualMain .productV2VisualThumbsSlide[data-index="${productSwiper + 1}"]`).forEach(el => el.classList.add("active"));

    // pause all videos
    document.querySelectorAll(".productV2VisualSwiperSlide video").forEach(element => {
        element.pause();
    });
});

// play video on slide play click
document.querySelectorAll(".productV2VisualMain .productV2VisualSwiperSlide").forEach(element => {
    element.addEventListener("click", function () {
        // get video
        const video = this.closest(".productV2VisualMain .productV2VisualSwiperSlide").querySelector("video");

        // remove play button if it hasn't already been removed
        this.querySelector(".productV2VisualMain .productV2VisualSwiperSlidePlay")?.remove();

        if (video) {
            // show controls
            video.controls = true;

            // play video
            video.play();
        }
    });
});

// change slide on thumbnail click
document.querySelectorAll(".productV2VisualMain .productV2VisualThumbsSlide").forEach(element => {
    element.addEventListener("click", function () {
        // change slide
        mainSwiper.slideTo(this.dataset.index - 1);
    });
});

// mobile thumbnail swiper
const mainThumbnailSwiper = new Swiper(document.querySelector(".productV2VisualMainSwiperThumbs .swiper"), {
    slidesPerView: 'auto',
    // loop: true,
    navigation: {
        nextEl: '.productV2VisualMainSwiperThumbs .swiper-button-next',
        prevEl: '.productV2VisualMainSwiperThumbs .swiper-button-prev',
    },
});

// mobile active add
document.querySelectorAll(".productV2VisualThumbsSlide.swiper-slide").forEach(element => {
    element.addEventListener("click", function () {
        document.querySelector('.productV2VisualThumbsSlide.swiper-slide.active')?.classList.remove('active');
        this.classList.add('active');
    });
});

// View all button swaps to main images
if (document.querySelector('.productV2Gallery')) {
    document.querySelector('.productV2Gallery').addEventListener("click", () => {
        document.querySelector('.productV2Visual').classList.add('mainVisual');
    })
}

// clicking an already selected color will show variant gallery again
document.querySelectorAll('.productV2OptionItemValuesLabel').forEach(element => {
    element.addEventListener("click", function () {
        document.querySelector('.productV2Visual').classList.remove('mainVisual');
    })
})

/**************
 Product Variants
 ***************/

// variable for the product form element
const productFormATC = document.querySelector(".productV2FormATC");

// update active variant on input changes
document.querySelectorAll(".productV2OptionItemValuesLabel").forEach(function (element) {
    element.addEventListener("input", function () {

        //update bottom ATC to match top
        const value = element.querySelector('input').value;
        const name = element.querySelector('input').name;
        document.querySelector(`.productV2BottomRight select[name="${name}"]`).value = value;

        updateBottomVariant();
        updateUnavailableOptions();
        updateProduct().catch(e => console.error(e));
    });
})

// update quantity on input change
document.querySelector(".productV2FormQuantityInput")?.addEventListener("input", function () {
    document.querySelector(".productV2BottomQuantityInput").value = this.value;
});
document.querySelector(".productV2BottomQuantityInput")?.addEventListener("input", function () {
    document.querySelector(".productV2FormQuantityInput").value = this.value;
});

// update active variant
async function updateProduct() {
    // collect options from inputs
    let options = [];
    document.querySelectorAll(`.productV2OptionItemValuesLabelInput:checked`).forEach(element => {
        options.push(element.value);
    });

    if (options.length !== 0) {
        // find new variant based on the options
        activeVariant = product.variants.find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify(options)
        });
    }

    // check if variant wasn't found
    if (activeVariant === null || activeVariant === undefined) {

        // try to find new size
        const foundNewSize = nextAvailableSize();

        // fall back if no sizes available
        if (!foundNewSize) {
            productFormATC.classList.add("disabled");
            productFormATC.textContent = "Not Available";
        }
        // return no matter what
        return;
    }

    // update variant
    document.querySelector('.productV2FormVariant').value = activeVariant.id;

    // update color title if available
    if (document.querySelector('.productV2OptionItemValues.color') && document.querySelector('.productV2OptionItemLabelTitle')) {
        document.querySelector('.productV2OptionItemLabelTitle').textContent = document.querySelector('.productV2OptionItemValues.color .productV2OptionItemValuesLabelInput:checked').value;
    }

    // update intelligems id
    document.querySelectorAll('.productV2PriceReal, .productV2PriceCompare, .productV2PriceSavings').forEach(el => {
        el.setAttribute('data-variant-id', activeVariant.id);
    });

    // update price
    document.querySelector(".productV2PriceReal").textContent = price(activeVariant.price);
    if (activeVariant.compare_at_price > activeVariant.price) {
        document.querySelector(".productV2PriceReal").classList.add("sale");
        document.querySelector(".productV2PriceCompare").textContent = price(activeVariant.compare_at_price);
        document.querySelector(".productV2PriceSavings").textContent = `Save ${Math.round((activeVariant.compare_at_price - activeVariant.price) * 100 / activeVariant.compare_at_price)}%`;
    } else {
        document.querySelector(".productV2PriceReal").classList.remove("sale");
        document.querySelector(".productV2PriceCompare").textContent = "";
        document.querySelector(".productV2PriceSavings").textContent = "";
    }

    // check if the variant is in stock
    if (activeVariant.available) {
        productFormATC.classList.remove("disabled");
        productFormATC.textContent = "Add To Cart";
    } else {
        // for multi-option products (e.g. color + size), try to find an available size
        if (product.options.length > 1) {
            const foundNewSize = nextAvailableSize();
            if (foundNewSize) {
                return;
            }
        }
        productFormATC.classList.add("disabled");
        productFormATC.textContent = "Sold Out";
    }

    try {
        // update afterpay variant
        afterpay_current_variant = activeVariant;

        // update display price
        const afterpayElement = document.querySelector('[data-mpid="muscle-mat.myshopify.com"]');
        if (afterpayElement) afterpayElement.dataset.amount = activeVariant.price / 100;
    } catch (e) {
        console.error("Error updating afterpay pricing")
    }

    try {
        // if page with style choices, use selected path to ensure proper images
        if (document.querySelector('.productV2StyleItem.active')) {
            let path = document.querySelector('.productV2StyleItem.active')?.href || window.location.pathname;
            const response = await fetch(`${path}?variant=${activeVariant.id}&sections=main-product-v2`)
            if (response.ok) {
                const data = await response.json();
                const content = data["main-product-v2"]
                // create a new element and parse out contents
                const contentDiv = document.createElement('div');
                contentDiv.innerHTML = content;
                const newSwiper = contentDiv.querySelector('.productV2VisualVariant').innerHTML;
                // destroy old swiper and update with new media
                if (newSwiper) {
                    await productSwiper.destroy(true, true);
                    document.querySelector('.productV2VisualVariant').innerHTML = contentDiv.querySelector('.productV2VisualVariant').innerHTML;
                    // run the event listeners
                    initSwiper();
                    // show the variant swiper
                    document.querySelector('.productV2Visual').classList.remove('mainVisual');
                }
            }
        } else {
            // no special selector, try to find variant image
            if (activeVariant.featured_image) {
                // change active slide
                productSwiper.slideTo(activeVariant.featured_image.position - 1);
            }
        }
    } catch (e) {
        console.warn("Variant image unable to update");
        console.error(e);
    }

    // update url with variant id so the selected options are maintained on refresh
    let url = new URL(window.location.href);
    url.searchParams.set("variant", activeVariant.id);
    window.history.replaceState({}, "", url);
}

// update color title if available on load
if (document.querySelector('.productV2OptionItemValues.color') && document.querySelector('.productV2OptionItemLabelTitle')) {
    document.querySelector('.productV2OptionItemLabelTitle').textContent = document.querySelector('.productV2OptionItemValues.color .productV2OptionItemValuesLabelInput:checked').value;
}

/*
 * Disable size options that are not available for the selected color
 */
function updateUnavailableOptions() {
    // if the product option has Colour and Size
    if (product.options.length !== 2) {
        return;
    }

    // make sure the 1st option is color
    if (product.options[0] !== "Colour" && product.options[0] !== "Colour") {
        return;
    }

    // make sure the 2nd option is size
    if (product.options[1] !== "Size") {
        return;
    }

    // collect options from inputs
    const options = [];
    document.querySelectorAll(`.productV2OptionItemValuesLabelInput:checked`).forEach(element => {
        options.push(element.value);
    });

    // get the current selected color and size
    const selectedColor = options[0];
    const selectedSize = options[1];

    // loop over ever size input
    document.querySelectorAll('.productV2OptionItem[data-value="Size"] .productV2OptionItemValuesLabelInput').forEach(sizeInput => {
        // skip if this is the selected size since we don't want to disable an option that is selected
        if (sizeInput.value === selectedSize) return;

        // get the size value in the loop
        const sizeValue = sizeInput.value;

        // create array of options BUT with the current size in the loop
        const testOptions = [selectedColor, sizeValue];

        // check if a variant exists with these options
        const testVariant = product.variants.find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify(testOptions)
        });

        // if the variant doesn't exist or isn't available, disable the size option
        sizeInput.disabled = testVariant === null || testVariant === undefined || !testVariant.available;
    });
}

updateUnavailableOptions();

// find an available size
function nextAvailableSize() {

    // ensure product has two options, behavior on only size is disruptive
    if (product.options.length !== 2) {
        return;
    }

    // get all size inputs
    const sizeInputs = document.querySelectorAll('.productV2OptionItem[data-value="Size"] .productV2OptionItemValuesLabelInput');

    for (let input of sizeInputs) {
        // if one is not disabled or selected, activate
        if (!input.disabled && !input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('input', {bubbles: true}));
            return true;
        }
    }
    // none found
    return false;
}

/**************
 Product ATC
 ***************/

document.querySelector(".productV2Form").addEventListener("submit", async function (e) {
    e.preventDefault();

    // add loading animation
    document.querySelector(".productV2FormATC").classList.add("loading");

    // add product
    const addedProduct = await addProduct(new FormData(this));

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // remove loading animation
    document.querySelector(".productV2FormATC").classList.remove("loading");

    // open cart
    await openCart(addedProduct);
});

/**************
 Product Bottom
 ***************/

// show on scroll
let isVisible = false;
const productBottom = document.querySelector('.productV2Bottom');

// listen if the original ATC button is scrolled off screen
window.addEventListener('scroll', function () {
    const scrollTop = window.scrollY;
    const buttonOffsetTop = productFormATC.offsetTop;

    if (scrollTop > buttonOffsetTop && !isVisible) {
        productBottom.classList.add('active');
        isVisible = true;
    } else if (scrollTop <= buttonOffsetTop && isVisible) {
        productBottom.classList.remove('active');
        isVisible = false;
    }
})

// update active variant on input changes
document.querySelectorAll(".productV2BottomOptionItem").forEach(function (el) {
    el.addEventListener("change", function () {
        // update top selection to match  bottom
        const value = el.value;
        document.querySelector(`.productV2OptionItemValuesLabel [value="${value}"]`).click();
        updateBottomVariant();
    });
})

// initial variant
let bottomVariant = activeVariant;

// currency
let bottomCurrency = document.querySelector('.productV2BottomPrice').textContent.split(" ")[1];

// update active variant
function updateBottomVariant() {
    // collect options from inputs
    let options = [];
    document.querySelectorAll(`.productV2BottomOptionItem`).forEach(select => {
        options.push(select.value);
    });

    // find new variant based on the options
    bottomVariant = product.variants.find((variant) => {
        return JSON.stringify(variant.options) === JSON.stringify(options)
    });

    // check if variant wasn't found
    if (bottomVariant === null || bottomVariant === undefined) {
        document.querySelector(".productV2BottomATC").classList.add("disabled");
        document.querySelector(".productV2BottomATC").textContent = "Not Available";
        return;
    }

    // update variant
    document.querySelector('.productV2BottomVariant').value = bottomVariant.id;

    // update price
    document.querySelector(".productV2BottomPrice").textContent = price(bottomVariant.price) + ` ${bottomCurrency}`;

    // check if the variant is in stock
    if (bottomVariant.available) {
        document.querySelector(".productV2BottomATC").classList.remove("disabled")
        document.querySelector(".productV2BottomATC").textContent = "Add To Cart";
    } else {
        document.querySelector(".productV2BottomATC").classList.add("disabled");
        document.querySelector(".productV2BottomATC").textContent = "Sold Out";
    }
}

/**************
 Product ATC
 ***************/

document.querySelector(".productV2BottomRight").addEventListener("submit", async function (e) {
    e.preventDefault();

    // add loading animation
    document.querySelector(".productV2BottomATC").classList.add("loading");

    // add product
    const addedProduct = await addProduct(new FormData(this));

    // remove loading animation
    document.querySelector(".productV2BottomATC").classList.remove("loading");

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // open cart
    await openCart(addedProduct);
});